import React, { useState } from 'react';
import { useEffect } from 'react';
import { Button, Card, Col, Row } from "react-bootstrap";
import { Form, Table, Whisper, Tooltip } from 'rsuite';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import supervisingProfessionalService from '../../../services/supervisingProfessional.service';
import GenericBadge from '../Badge/GenericBadge';
import LoadingSpinner from '../GenericComponents/LoadingSpinner';
import RedStar from "../GenericComponents/RedStar";
import TextArea from '../GenericComponents/TextArea';
import LegacySendIcon from "@rsuite/icons/legacy/Send";
import LegacyFileTextIcon from "@rsuite/icons/legacy/FileText";
import ExternalFormModal from '../Modal/ExternalFormModal';
import axios from "axios";
import authHeader from "../../../services/authheader";
import DocumentUpload from '../../Shared/Upload/DocumentUpload'
import LegacyPlusIcon from "@rsuite/icons/legacy/Plus";
import AddNewSupervisingProfessionalModal from '../../Public/Firm/SupervisingProfessional/AddNewSupervisingProfessionalModal';

function SupervisingProfessionalWithAttestation(props) {
    const [supervisingLockerHasLoaded, setSupervisingLockerHasLoaded] = useState(false);
    const [supervisingProfessionals, setSupervisingProfessionals] = useState([]);
    const [verifierModalShow, setVerifierModalShow] = useState(false);
    const [addNewSupervisingProfessionalModalShow, setAddNewSupervisingProfessionalModalShow] = useState(false);
    const [currentAttestationId, setCurrentAttestationId] = useState();
    const [individualAttestationFileName, setIndividualAttestationFileName] = useState();
    let spType = "applicationSpAttestation";
    let attestationsLinks = "";

    switch (props.parentTypeId) {
        case 1:
            spType = "applicationSpAttestation";
            attestationsLinks = "/Reports/GetAllSpAttestationFormsByCredType?entityId=" + props.entityId + "&credTypeId=" + (props.prefix == 'EF' ? 1 : 2);
            break;
        case 2:
            spType = "reinstatementSpAttestation";
            attestationsLinks = "/Reports/GetAllSpAttestationFormsByCredType?entityId=" + props.entityId + "&credTypeId=" + (props.prefix == 'EF' ? 1 : 2);
            break;
        case 3:
            spType = "renewalSpAttestation";
            attestationsLinks = "/Reports/GetAllSpAttestationFormsByCredType?entityId=" + props.entityId + "&credTypeId=" + (props.prefix == 'EF' ? 1 : 2);
            break;
    }
    useEffect(() => {
        if (props.isInternal && props.entityId && props.prefix) {
            supervisingProfessionalService.getSupervisingProfessionalsByLicenseType(props.entityId, props.prefix).then((result) => { setSupervisingProfessionals(result.data) }).then(() => {
                setSupervisingLockerHasLoaded(true)
            });
        }
        if (props.entityId && props.parentTypeId && props.parentId) {
            reloadAttestationGrid();
        }
    }, [props.entityId])
    const downloadAttestations = () => {
        if (!supervisingProfessionalAttestations.some(x => x.statusId === 4 || x.statusId === 5)) {
            Swal.fire({
                icon: 'error',
                text: "There are currently no attestation forms to download. Refer to Supervising Professional Attestations instructions above for submitting online attestations forms",
                confirmButtonText: "I understand"
            });
            return;
        }
        var urlProps = {
            url: process.env.REACT_APP_APIURL + attestationsLinks,
            name: `Supervising Professional Attestations for ${props.firmName}${props.firmCredential ? (" (" + props.firmCredential + ")") : ""} ${new Date().toISOString().split('T')[0]}.pdf`
        };
        Swal.fire({
            title: 'Generating PDF',
            didOpen: () => {
                Swal.showLoading();
                axios.post(urlProps.url, null, { headers: authHeader(), responseType: 'arraybuffer' }).then((response) => {
                    var name = new String(response.headers['content-disposition']);
                    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', urlProps.name);
                    document.body.appendChild(link);
                    Swal.close()
                    link.click();
                    link.remove();
                });
            },
            allowOutsideClick: false
        })
    }
    const [supervisingProfessionalAttestationsHasLoaded, setSupervisingProfessionalAttestationsHasLoaded] = useState(false);
    const [supervisingProfessionalAttestations, setSupervisingProfessionalAttestations] = useState([]);

    const reloadAttestationGrid = () => {
        setSupervisingProfessionalAttestationsHasLoaded(false);
        supervisingProfessionalService.getSupervisingProfessionalAttestations(props.entityId, props.prefix).then((result) => {
            setSupervisingProfessionalAttestations(result.data)
        }).then(() => {
            setSupervisingProfessionalAttestationsHasLoaded(true)
        });
    }
    return (<>
        {verifierModalShow &&
            <ExternalFormModal show={verifierModalShow} onHide={() => setVerifierModalShow(false)} id={currentAttestationId} type={spType} fileName={individualAttestationFileName} />
        }
        <AddNewSupervisingProfessionalModal
            parentId={props.parentId}
            parentTypeId={props.parentTypeId}
            prefix={props.prefix}
            show={addNewSupervisingProfessionalModalShow} onHide={() => setAddNewSupervisingProfessionalModalShow(false)} updateGrid={reloadAttestationGrid} />
        <Card>
            <Card.Header>
                <Row>
                    <Col>
                        <h4>Supervising Professional Attestations</h4>
                    </Col>
                    {(!props.isReadOnly && !props.isInternal) &&
                        <Col>
                            <div className="text-end">
                                <Button onClick={() => { setAddNewSupervisingProfessionalModalShow(true); }}> <LegacyPlusIcon /> Add New Supervising Professional</Button></div>
                        </Col>
                    }
                </Row>

            </Card.Header>
            <Card.Body>
                {props.isInternal && <>
                    <br />{supervisingLockerHasLoaded ?
                        <>
                            <Table wordWrap autoHeight data={supervisingProfessionals}>
                                <Table.Column flexGrow={1}>
                                    <Table.HeaderCell>
                                        Name
                                    </Table.HeaderCell>
                                    <Table.Cell>
                                        {rowData => (rowData.professionalFormattedName)}
                                    </Table.Cell>
                                </Table.Column>
                                <Table.Column flexGrow={1}>
                                    <Table.HeaderCell>
                                        License #
                                    </Table.HeaderCell>
                                    <Table.Cell>
                                        {rowData => (rowData.codeVerificationStatus?.verificationStatus === "Approved" ? <Button variant="link" style={{ 'padding': 0 }} href={"internal/indCredential?entityId=" + rowData.professionalEntityId} target="_blank" >{rowData.professionalFormattedLicenseNumber}</Button> : rowData.professionalFormattedLicenseNumber)}
                                    </Table.Cell>
                                </Table.Column>
                                <Table.Column flexGrow={1}>
                                    <Table.HeaderCell>
                                        Owner of this firm?
                                    </Table.HeaderCell>
                                    <Table.Cell>
                                        {rowData => (rowData.isOwner ? "+25% or more" : "No")}
                                    </Table.Cell>
                                </Table.Column>
                                <Table.Column flexGrow={1}>
                                    <Table.HeaderCell>
                                        Sent Date
                                    </Table.HeaderCell>
                                    <Table.Cell>
                                        {rowData => (rowData.sentDate ? new Date(rowData.sentDate).toLocaleDateString() : '')}
                                    </Table.Cell>
                                </Table.Column>
                                <Table.Column flexGrow={1}>
                                    <Table.HeaderCell>
                                        Response Date
                                    </Table.HeaderCell>
                                    <Table.Cell>
                                        {rowData => (rowData.responseDate ? new Date(rowData.responseDate).toLocaleDateString() : '')}
                                    </Table.Cell>
                                </Table.Column>
                                <Table.Column flexGrow={1}>
                                    <Table.HeaderCell>
                                        Verification Status
                                    </Table.HeaderCell>
                                    <Table.Cell>{rowData => (rowData.codeVerificationStatus?.verificationStatus ? <GenericBadge status={rowData.codeVerificationStatus.verificationStatus.toUpperCase()} /> : '')}</Table.Cell>
                                </Table.Column>
                            </Table>
                            
                            <br />
                            <br />
                            <br />
                        </> : <LoadingSpinner />
                    }
                </>
                }

                {(props.isInternal && props.isReadOnly) ? <></> : supervisingProfessionalAttestationsHasLoaded ? <>
                    {!props.isInternal &&
                        <Row>
                            <Col>
                                <b>Follow the steps below for assigning SP's and/or sending to your existing SP's a link to complete the online attestation form:</b>
                                <br /><br />
                                <b>For SP's already assigned:</b>
                                <ul>
                                    <li>
                                        If the firm already has an SP assigned, and the "Verification Status" below displays as "Not Yet Sent" or "Expired", that SP needs to complete an online attestation form. Click the "Send email for attestation" icon below to email a secure link to the SP for the online attestation form. If "Verification Status" displays as "Pending", then a secure link has already been sent to the SP's registered email address with LAPELS. Click the paper airplane to resend the email with secure link if necessary.
                                    </li>
                                    <li>
                                        Once the SP has submitted the online attestation form, the verification status below will update to "Verified". The firm application, renewal, or reinstatement can now be completed.
                                    </li>
                                    <li>
                                        Both designated SP and firm registered email addresses will receive a PDF attachment of the online attestation form. You may also view the completed form(s) below for active SP’s by clicking the "View attestation response" icon in the “Supervising Professional Attestations” grid below. If you have multiple SP's, you can also click the "Download All Attestations" button to package and download all attestation forms into a single PDF document.
                                    </li>
                                    <li>
                                        The attestation form is good for 2 years, which is reflected in the "Valid Through" column below.
                                    </li>
                                </ul>
                                <br /><br />
                                <b>If the firm needs a replacement SP:</b>
                                <ul>
                                    <li>
                                        Click “Add New Supervising Professional”
                                    </li>
                                    <li>
                                        Enter license number into “License #” box. When the full name/license number appears underneath, select that option to add.
                                    </li>
                                    <li>
                                        Mark “Yes” or “No” to “Owner of this firm?” Click “Add New”
                                    </li>
                                    <li>
                                        Upon clicking “Add New”, the designated SP will show in the Supervising Professional Attestations section as “Pending”, and the SP will receive an Attestation Request at the SP’s registered email address to complete the online SP Attestation Form via a secure link.
                                    </li>
                                    <li>
                                        Once the SP completes the attestation form, SP status in the Supervising Professional Attestations section will change from “Pending” to “Verified”.
                                    </li>
                                    <li>
                                        Once the SP is in “Verified” status, click <a target='_blank' href="/firm/supervisingprofessional">here</a> to open your firm’s SP locker in a new tab to remove any SP no longer with your firm.
                                    </li>
                                    <li>
                                        Both designated SP and firm registered email addresses will receive a PDF attachment of the online attestation form. You may also view the completed form(s)
                                        below for active SP’s by clicking the "View attestation response" icon in the “Supervising Professional Attestations” grid below. If you have multiple SP's,
                                        you can also click the "Download All Attestations" button to package and download all attestation forms into a single PDF document.
                                    </li>
                                    <li>
                                        After completing the above steps, the firm application, renewal, or reinstatement can be completed.
                                    </li>
                                    <li>
                                        The attestation form is good for 2 years, which is reflected in the "Valid Through" column below.
                                    </li>
                                </ul>

                                <br/><br/>
                                <h4>SP Attestation Icon Legend</h4>
                                <br/>
                                <ul>
                                    <li>                
                                        <LegacySendIcon
                                        title="Send email for attestation"
                                        style={{ cursor: "pointer", fontSize: "2em" }}/> - Send email for attestation
                                    </li>
                                    <li>                
                                        <LegacyFileTextIcon
                                        title="View attestation response"
                                        style={{ cursor: "pointer", fontSize: "2em" }}/> - View attestation response
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    }
                    <Table wordWrap autoHeight data={supervisingProfessionalAttestations}>
                        <Table.Column flexGrow={2}>
                            <Table.HeaderCell>
                                Name
                            </Table.HeaderCell>
                            <Table.Cell>
                                {rowData => (rowData.name)}
                            </Table.Cell>
                        </Table.Column>
                        <Table.Column flexGrow={.5}>
                            <Table.HeaderCell>
                                License #
                            </Table.HeaderCell>
                            <Table.Cell>
                                {rowData => (rowData.licenseNumber)}
                            </Table.Cell>
                        </Table.Column>
                        <Table.Column flexGrow={.5}>
                            <Table.HeaderCell>
                                Verification Status
                            </Table.HeaderCell>
                            <Table.Cell>{rowData => {
                                var status = "";
                                switch (rowData.statusId) {
                                    case 1:
                                        status = "Pending";
                                        break;
                                    case 4:
                                        status = "Verified";
                                        break;
                                    case 5:
                                        status = "Expired";
                                        break;
                                    default:
                                        status = "Not Yet Sent";
                                        break;
                                }
                                return (status ? <GenericBadge status={status.toUpperCase()} /> : '')
                            }}
                            </Table.Cell>
                        </Table.Column>
                        <Table.Column flexGrow={.5}>
                            <Table.HeaderCell>
                                Valid Through
                            </Table.HeaderCell>
                            <Table.Cell>
                                {rowData => (rowData.expirationDate ? new Date(rowData.expirationDate).toLocaleDateString() : '')}
                            </Table.Cell>
                        </Table.Column>
                        <Table.Column flexGrow={.25}>
                            <Table.HeaderCell>
                            </Table.HeaderCell>
                            <Table.Cell dataKey="professionalEntityId">
                                {rowData => {
                                    const createSpAttestation = () => {
                                        if (!props.isReadOnly) {
                                            //rowData.entityId = props.entityId
                                            if (props.isInternal) {
                                                if (rowData.spattestationId) {
                                                    supervisingProfessionalService.sendSpAttestationEmail(rowData).then((emailReturn) => {
                                                        if (emailReturn.data) {
                                                            reloadAttestationGrid()
                                                            Swal.fire("Success", `Email has been successfully sent to ${rowData.professionalEmailAddress}.`, "success")
                                                        }
                                                    }).catch((error) => {
                                                        Swal.fire("Error", error.response.data, "error")
                                                    });
                                                }
                                                else {
                                                    Swal.fire("Error", "Could not sent email beacuse no attestation record was found and you cannot make one right now.", "error");
                                                }
                                            } else {
                                                supervisingProfessionalService.createSpAttestation(rowData.licenseNumber).then((result) => {
                                                    if (result.data) {
                                                        reloadAttestationGrid()
                                                        Swal.fire("Success", `Email has been successfully sent to ${rowData.professionalEmailAddress}.`, "success")
                                                    }
                                                }).catch((error) => {
                                                    Swal.fire("Error", error.response.data, "error")
                                                });
                                            }
                                        }
                                    }
                                    const viewAttestation = () => {
                                        setIndividualAttestationFileName(`${rowData.name} (${rowData.licenseNumber}) SP Attestation Form ${new Date().toISOString().split('T')[0]}`)
                                        console.log(rowData)
                                        setVerifierModalShow(true);
                                        setCurrentAttestationId(rowData.spattestationId);
                                    }


                                    if (rowData.statusId == 4) {
                                        return (<>
                                            <Whisper placement="top" trigger="hover" speaker={<Tooltip>
                                                View attestation response.
                                            </Tooltip>}>
                                                <LegacyFileTextIcon
                                                    title="View attestation response"
                                                    onClick={viewAttestation}
                                                    style={{ cursor: "pointer", fontSize: "2em", marginRight: ".5em" }} />
                                            </Whisper>
                                        </>
                                        );
                                    }
                                    else {
                                        return (<>
                                            {!props.isReadOnly &&
                                                <Whisper placement="top" trigger="hover" speaker={<Tooltip>
                                                    Send email for attestation.
                                                </Tooltip>}>
                                                    <LegacySendIcon
                                                        title="Send email for attestation"
                                                        onClick={createSpAttestation}
                                                        style={{ cursor: props.isReadOnly ? "default" : "pointer", fontSize: "2em" }}
                                                    />
                                                </Whisper>
                                            }
                                        </>
                                        );
                                    }
                                }}
                            </Table.Cell>
                        </Table.Column>
                    </Table>
                    <br />
                    <Row>
                        <Col className="text-end mb-3">
                            <Button onClick={downloadAttestations}>Download All Attestations</Button>
                        </Col>
                    </Row>  </> : <LoadingSpinner />}
                <br />


                {!props.isRenewal &&
                    <Card style={{ padding: '1rem' }}>
                        <DocumentUpload
                            isUserEditable={!props.isReadOnly}
                            credentialTypeId={props.prefix == 'EF' ? 1 : 2}
                            sectionId={props.sectionId}
                            parentId={props.sectionDataId}
                            parentTypeId={props.parentTypeId}
                            entityId={props.entityId}
                            filterOutAttachmentTypeIds={(props.isReadOnly && props.isInternal) ? null : [20]}
                            warningMessage={<i className='colorRed'>(select quiz type from dropdown and click "Upload". Repeat for each quiz type.)</i>}
                            fileUploadTitle={"Quiz File Upload"}
                        />
                    </Card>
                }
                <br />
                <Row>
                    <Col sm={4}>
                        <h5>Electronic Signature of Supervising Professional(s):<RedStar /></h5>
                        <span>(Type full name of each Supervising Professional, separated by commas)</span>
                    </Col>
                    <Col sm={8}>
                        <Form.Group>
                            <Form.ControlLabel className="d-none">Electronic Signature of Supervising Professional</Form.ControlLabel>
                            <Form.Control
                                accepter={TextArea}
                                rows={2}
                                readOnly={props.isReadOnly}
                                name="electronicSignature" />
                            <Form.HelpText className="d-none">Electronic Signature of Supervising Professional</Form.HelpText>
                        </Form.Group>
                    </Col>
                </Row>
            </Card.Body>
        </Card >
    </>
    );
}
export default SupervisingProfessionalWithAttestation;